import clx from 'classnames'
import styles from './DateTimeRange.css'

const DateTimeRange = ({ className }) => {
  return (
    <span className={clx(styles.DateTimeRange, className)} />
  )
}

export default DateTimeRange
